import { useEffect, useState } from 'react';

import { getInboundTokenService } from 'services/inbound_email.service';

export interface InboundTokenState {
  code: string | null;
  expiresAt: Date | null;
  /** Segundos até expirar (0 = expirado ou sem código). */
  secondsLeft: number;
}

const POLL_MS = 5000;

/**
 * Código de verificação que a distribuidora mandou ao alias (C2 — out/2026).
 * O backend já guardava o código no Redis por 5 minutos e só o repassava por
 * e-mail; a tela não mostrava. Consulta a cada 5 s enquanto `active` (o passo
 * do assistente aberto) e conta o tempo restante a cada segundo.
 */
export const useInboundToken = (active: boolean): InboundTokenState => {
  const [code, setCode] = useState<string | null>(null);
  const [expiresAt, setExpiresAt] = useState<Date | null>(null);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!active) return undefined;
    let alive = true;
    const poll = () =>
      getInboundTokenService()
        .then(({ data }) => {
          if (!alive) return;
          setCode(data.data.code);
          setExpiresAt(
            data.data.expiresAt ? new Date(data.data.expiresAt) : null
          );
        })
        .catch(() => {
          /* falha de rede — tenta de novo no próximo ciclo */
        });
    poll();
    const pollId = window.setInterval(poll, POLL_MS);
    const tickId = window.setInterval(() => setNow(Date.now()), 1000);
    return () => {
      alive = false;
      window.clearInterval(pollId);
      window.clearInterval(tickId);
    };
  }, [active]);

  const secondsLeft = expiresAt
    ? Math.max(0, Math.round((expiresAt.getTime() - now) / 1000))
    : 0;

  return { code: secondsLeft > 0 ? code : null, expiresAt, secondsLeft };
};
